import { Editor, Path, Range, Transforms, Element as SlateElement } from 'slate';
import { createLinkNode, createParagraphNode } from './utils';

// "inspired by" https://dev.to/koralarts/slatejs-adding-images-and-links-2g93
export const removeLink = (editor, opts = {}) => {
    Transforms.unwrapNodes(editor, {
        ...opts,
        match: (n) => !Editor.isEditor(n) && SlateElement.isElement(n) && n.type === 'link'
    });
};

export const insertLink = (editor, url) => {
    if (!url) {
        return;
    }

    const { selection } = editor;
    const link = createLinkNode(url, url);

    if (selection) {
        const [parentNode, parentPath] = Editor.parent(editor, selection.focus?.path);

        if (parentNode.type === 'link') {
            removeLink(editor);
        }

        if (editor.isVoid(parentNode)) {
            // Insert the new link after the void node
            Transforms.insertNodes(editor, createParagraphNode([link]), {
                at: Path.next(parentPath),
                select: true,
            });
        } else if (Range.isCollapsed(selection)) {
            // Insert the new link in our last known location
            Transforms.insertNodes(editor, link, { select: true });
        } else {
            // Wrap the currently selected range of text into a Link
            Transforms.wrapNodes(editor, link, { split: true });
            // Remove the highlight and move the cursor to the end of the highlight
            Transforms.collapse(editor, { edge: 'end' });
        }
    } else {
        Transforms.insertNodes(editor, createParagraphNode([link]));
    }
};

export const withLinks = (editor) => {
    const { isInline } = editor;

    editor.isInline = (element) => (element.type === 'link' ? true : isInline(element));

    return editor;
};
